import * as types from "./mutationTypes";

export default {
  [types.SET_SSO](state, sso) {
    state.sso = sso;
  },
  [types.CLEAR_SSO](state) {
    state.sso = null;
  },
  [types.ADD_GROUP](state) {
    state.sso.sso.push({ sso_group_name: null, team_uuid: null });
  },
  [types.REMOVE_GROUP](state, index) {
    state.sso.sso.splice(index, 1);
  },
  [types.SET_GROUP_NAME](state, { index, name }) {
    state.sso.sso[index].sso_group_name = name;
  },
  [types.SET_GROUP_TEAM](state, { index, teamUUID }) {
    state.sso.sso[index].team_uuid = teamUUID;
  },
  [types.SET_DEFAULT](state, teamUUID) {
    state.sso.sso_default = teamUUID;
  }
};
